import React from 'react';
import { HardDrive } from 'lucide-react';

const ReplicationSetup = () => {
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg shadow-sm">
      <div className="p-6 border-b border-slate-700">
        <div className="flex items-center">
          <HardDrive className="w-6 h-6 text-blue-400 mr-3" />
          <div>
            <h2 className="text-xl font-semibold text-slate-200">Database Replication Setup</h2>
            <p className="text-slate-400 mt-1">Configure database replication and backup strategies</p>
          </div>
        </div>
      </div>

      <div className="p-6">
        <div className="text-center py-12">
          <HardDrive className="w-16 h-16 text-slate-600 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-slate-300 mb-2">Database Replication Setup</h3>
          <p className="text-slate-400">This page will contain database replication configuration functionality.</p>
        </div>
      </div>
    </div>
  );
};

export default ReplicationSetup;